import { render, staticRenderFns } from "./MeetingCount2.vue?vue&type=template&id=24979ce2&scoped=true"
import script from "./MeetingCount2.vue?vue&type=script&lang=ts"
export * from "./MeetingCount2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24979ce2",
  null
  
)

export default component.exports